export default "__VITE_ASSET__SsF$oPe9__"